<div class="field">
    <label class="label light-blue">{{ label }}</label>
  
    <div class="dropdown-container" (click)="toggleDropdown()" #dropdown>
      <div class="dropdown-header">
        {{ selectedOption || 'Seleccione: ' + label }}
        <i *ngIf="!selectedOption" class="dropdown icon"></i>
        <i *ngIf="selectedOption" class="times icon" (click)="clear()"></i>
      </div>

      <!-- Input de búsqueda -->
      <input *ngIf="showDropdown" class="input-select" type="text" [(ngModel)]="filterText"
             (input)="filterSections()" placeholder="Filtrar opciones..." (click)="$event.stopPropagation()"/>
  
      <!-- Lista de opciones -->
      <ul *ngIf="showDropdown" class="dropdown-options">
        <li *ngFor="let n of filtered" (click)="selectOption(n, $event)" [class.selected]="n === selectedOption">
          {{ n }}
        </li>
      </ul>
    </div>
  </div>
  